export default __webpack_public_path__ + "static/media/ic_tax.a7bcd707.svg";